// extracted by mini-css-extract-plugin
export default {"container":"IPodOuter_container__PKRXA"};